import type { RootState } from 'tradera/state/configure-store';
import type { CategoryNode } from 'tradera/backend/data/category-data';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { selectPreferredLanguageCode } from 'tradera/state/language/selectors';

type CategoriesRequest = {
    level: number;
};

type CategoriesResponse = CategoryNode[];

export const categoriesApi = createApi({
    reducerPath: 'categoriesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/categories',
    }),
    endpoints: (builder) => ({
        getCategories: builder.query<CategoriesResponse, CategoriesRequest>({
            queryFn: async (
                { level },
                { getState },
                _extraOptions,
                baseQuery,
            ) => {
                const languageCodeIso2: string = selectPreferredLanguageCode(
                    getState() as RootState,
                );

                const { data, ...response } = await baseQuery(
                    `/${level}?languageCodeIso2=${languageCodeIso2}&next=1`,
                );
                return { data: data as CategoryNode[], response };
            },
        }),
    }),
});

export const { useGetCategoriesQuery, endpoints } = categoriesApi;
